export enum DataFrameTableMode {
  // Show API IDs and blob dicts {id, name, url}
  RAW_WAREHOUSE = 'RAW_WAREHOUSE',
  // Show item names and blob previews
  TEXT = 'TEXT',
  // Show chips and blob previews
  RICH = 'RICH',
}
